import { useHistory } from 'react-router-dom';
import { t } from 'ttag';
import queryString from 'query-string';

import {
  login,
  registration,
} from '@urls';
import { Button } from '@ui/Button';

import s from './HeaderAuthLinks.sss';

interface Props {
  onLogin?: () => void,
  onRegister?: () => void,
}

export const HeaderAuthLinks: React.FC<Props> = ({
  onLogin,
  onRegister,
}) => {
  const history = useHistory();

  const handleLoginClick = () => {
    if (onLogin) {
      onLogin();
    } else {
      window.location.href = history.createHref({
        pathname: login,
        search: queryString.stringify({
          next: window.location.href,
        }),
      });
    }
  };

  const handleRegisterClick = () => {
    if (onRegister) {
      onRegister();
    } else {
      window.location.href = history.createHref({
        pathname: registration,
        search: queryString.stringify({
          next: window.location.href,
        }),
      });
    }
  };

  return (
    <div className={s.root}>
      <Button
        className={s.button}
        theme="text"
        onClick={handleLoginClick}
      >
        {t`Вхід`}
      </Button>

      <span className={s.delimiter}>|</span>

      <Button
        className={s.button}
        theme="text"
        onClick={handleRegisterClick}
      >
        {t`Реєстрація`}
      </Button>
    </div>
  );
};
